import semesters from 'keys/semesters'
import { getCurrentSemesterAndYear } from 'utils/general'

// שנה"ל לפי השנה הקלנדרית שבה היא מסתיימת
const hebrewYearNames = {
    2024: 'תשפ"ד',
    2025: 'תשפ"ה',
    2026: 'תשפ"ו',
    2027: 'תשפ"ז',
    2028: 'תשפ"ח',
    2029: 'תשפ"ט',
    2030: 'תש"ץ',
    2031: 'תשצ"א',
}

// "תמונת מצב סוף שנה תשפ"ו" — כותרת עמוד 1 לפי הסמסטר הנוכחי
export const getPresentationHeaderTitle = (semesterAndYear) => {
    const { semester, school_year } = semesterAndYear || getCurrentSemesterAndYear() || {}
    const semesterName = semesters?.find?.(s => s.id === semester?.id)?.name || ''
    const hebrewYear = hebrewYearNames[school_year?.id] || ''
    return `תמונת מצב ${semesterName} ${hebrewYear}`.trim()
}

export const slideTitles = [
    "",  // עמוד 1 — הכותרת מגיעה מ-getPresentationHeaderTitle
    "מה נבדק?",
    "תוצאות הקריאה",
    "תוצאות הקריאה בהשוואה בין בתי הספר בעיר",
    "איך מתפקדים בכיתה למרות הקושי?",
    "הצעדים הבאים לצמצום פערים - מה צריך ומי מקבל",
    "האם המענה עובד?",
]

// עזרי שכבות גיל — משותפים לעמודי "מי נמדד" ו"מה נבדק"
export const GRADE_ORDER = ['א', 'ב', 'ג', 'ד', 'ה', 'ו', 'ז', 'ח', 'ט', 'י', 'יא', 'יב']

// סיווג יסודי/חטיבה — משמש גם לספירה (useSlide2Data) וגם לסינון רשימת המוסדות בפאנל הצד
export const ELEMENTARY_GRADE_LETTERS = ['א', 'ב', 'ג', 'ד', 'ה', 'ו']
export const MIDDLE_GRADE_LETTERS = ['ז', 'ח', 'ט']

// "כתה א" → "א", שמות אחרים (גן וכו') נשארים כמו שהם
export const gradeNameToLetter = (name) => name?.startsWith('כתה ') ? name.slice(4).trim() : name

export const sortGradeLetters = (letters) => [...letters].sort((a, b) => {
    const ia = GRADE_ORDER.indexOf(a), ib = GRADE_ORDER.indexOf(b)
    return (ia === -1 ? 99 : ia) - (ib === -1 ? 99 : ib)
})

export const formatGradesLabel = (letters) => letters.map(g => GRADE_ORDER.includes(g) ? `${g}'` : g).join(' ')

// עמוד "מה נבדק" — כל כרטיס עיצובי מאגד כמה קטגוריות בקנד (Category.name);
// השכבות מגיעות מהשרת לפי הסוללות שהוקצו בפועל
export const foundationCategories = [
    { label: "אותיות", description: "זיהוי האותיות הבודדות", iconText: "א", categoryNames: ["LETTER_NAMING", "LETTER_SOUNDS", "FINAL_LETTERS"] },
    { label: "תנועות", description: "זיהוי הניקוד וצליל התנועה", iconText: "אֵ", categoryNames: ["VOWEL_SOUND"] },
    { label: "צירופים", description: "חיבור אות + תנועה להברה", iconText: "אִי", categoryNames: ["LETTER_VOWEL_CLUSTERS"] },
]

export const fluencyCategories = [
    { label: "רשימות מילים", description: "מילים ללא הקשר - התמודדות עם מושגים חדשים", faIcon: "fa-regular fa-file-lines", categoryNames: ["REAL_WORDS", "REAL_WORDS_NO_NIKUD", "NONSENSE_WORDS"] },
    { label: "קטעים סיפוריים", description: "טקסט רציף", faIcon: "fa-regular fa-book-open", categoryNames: ["NARRATIVE_TEXT", "NARRATIVE_TEXT_NO_NIKUD", "BIBLICAL_TEXT"] },
    { label: "קטעי מידע", description: "תוכן לימודי כפי שמופיע בכיתה", faIcon: "fa-regular fa-newspaper", categoryNames: ["INFORMATIONAL_TEXT", "INFORMATIONAL_TEXT_NO_NIKUD"] },
]

// עמוד "תוצאות הקריאה" — תיאורי הדירוגים (מהגבוה לנמוך, תואם ratingListLabel9)
export const tierDescriptions = [
    "צובר את כל הנלמד ומעבר",
    "צובר את הנלמד בכיתה",
    "צובר חלקית, נשארים חורים",
    "נוגע במעט מהלמידה, הפער הולך וגדל",
    "כמעט מנותק מהנלמד בכיתה",
]

// נוסח המקרא (רבים — ממשיך את "X תלמידים ...") — לפי הפיגמה
export const tierLegendDescriptions = [
    "צוברים את כל הנלמד ומעבר",
    "צוברים את הנלמד בכיתה",
    "צוברים חלקית ונשארים חורים",
    "נוגעים במעט מהלמידה והפער הולך וגדל",
    "כמעט מנותקים מהנלמד בכיתה",
]

export const noDataText = "טרם הוזנו נתונים"
export const sidePanelEmptyText = "אין נתונים עדיין"
